var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "170px",
    viewBox: "0 0 217 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 78") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP-(Elvis)-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "start-1",
    transform: "translate(-91.000000, -273.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    transform: "translate(91.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#231F20",
    points: "49 33 49 183.657278 50.1125255 183.657278 50.1125255 34.1019496 76.8874745 34.1019496 76.8874745 197.897213 50.1125255 197.897213 50.1125255 192.431844 49 192.431844 49 199 78 199 78 33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#231F20",
    points: "77 0 77 199 122.216353 198.878213 122.21386 197.773736 78.0944467 197.892163 78.0944467 1.10447767 91.2893016 1.10447767 121.906384 20.1594473 121.864834 51.2469242 122.958449 51.2477641 123 19.5429555 91.7314015 0.0814709768 91.5992702 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#231F20",
    points: "97 50 97 198 98.1026728 198 98.1026728 51.1072613 128.594591 51.1072613 164.896489 90.4954514 164.896489 188.395034 166 188.395034 166 90.0618091 129.076382 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,87.8197309 L138.921311,87.8197309 L138.921311,83.1811659 L135.079508,83.1811659 L135.079508,87.8197309 Z M134,89 L140,89 L140,82 L134,82 L134,89 Z",
    id: "Fill-4",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,97.8197309 L138.921311,97.8197309 L138.921311,93.1802691 L135.079508,93.1802691 L135.079508,97.8197309 Z M134,99 L140,99 L140,92 L134,92 L134,99 Z",
    id: "Fill-5",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,108.819731 L138.921311,108.819731 L138.921311,104.181166 L135.079508,104.181166 L135.079508,108.819731 Z M134,110 L140,110 L140,103 L134,103 L134,110 Z",
    id: "Fill-6",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,119.819731 L138.921311,119.819731 L138.921311,115.180269 L135.079508,115.180269 L135.079508,119.819731 Z M134,121 L140,121 L140,114 L134,114 L134,121 Z",
    id: "Fill-7",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,129.819731 L138.921311,129.819731 L138.921311,125.181166 L135.079508,125.181166 L135.079508,129.819731 Z M134,131 L140,131 L140,124 L134,124 L134,131 Z",
    id: "Fill-8",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,140.819731 L138.921311,140.819731 L138.921311,136.180269 L135.079508,136.180269 L135.079508,140.819731 Z M134,142 L140,142 L140,135 L134,135 L134,142 Z",
    id: "Fill-9",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,150.819731 L138.921311,150.819731 L138.921311,146.181166 L135.079508,146.181166 L135.079508,150.819731 Z M134,152 L140,152 L140,145 L134,145 L134,152 Z",
    id: "Fill-10",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,161.819731 L138.921311,161.819731 L138.921311,157.180269 L135.079508,157.180269 L135.079508,161.819731 Z M134,163 L140,163 L140,156 L134,156 L134,163 Z",
    id: "Fill-11",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,171.820628 L138.921311,171.820628 L138.921311,167.181166 L135.079508,167.181166 L135.079508,171.820628 Z M134,173 L140,173 L140,166 L134,166 L134,173 Z",
    id: "Fill-12",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.079508,182.819731 L138.921311,182.819731 L138.921311,178.181166 L135.079508,178.181166 L135.079508,182.819731 Z M134,184 L140,184 L140,177 L134,177 L134,184 Z",
    id: "Fill-13",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.078016,97.8197309 L148.920344,97.8197309 L148.920344,93.1802691 L145.078016,93.1802691 L145.078016,97.8197309 Z M144,99 L150,99 L150,92 L144,92 L144,99 Z",
    id: "Fill-14",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.078016,108.819731 L148.920344,108.819731 L148.920344,104.181166 L145.078016,104.181166 L145.078016,108.819731 Z M144,110 L150,110 L150,103 L144,103 L144,110 Z",
    id: "Fill-15",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.078016,119.819731 L148.920344,119.819731 L148.920344,115.180269 L145.078016,115.180269 L145.078016,119.819731 Z M144,121 L150,121 L150,114 L144,114 L144,121 Z",
    id: "Fill-16",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.078016,129.819731 L148.920344,129.819731 L148.920344,125.181166 L145.078016,125.181166 L145.078016,129.819731 Z M144,131 L150,131 L150,124 L144,124 L144,131 Z",
    id: "Fill-17",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.078016,140.819731 L148.920344,140.819731 L148.920344,136.180269 L145.078016,136.180269 L145.078016,140.819731 Z M144,142 L150,142 L150,135 L144,135 L144,142 Z",
    id: "Fill-18",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.078016,150.819731 L148.920344,150.819731 L148.920344,146.181166 L145.078016,146.181166 L145.078016,150.819731 Z M144,152 L150,152 L150,145 L144,145 L144,152 Z",
    id: "Fill-19",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.078016,161.819731 L148.920344,161.819731 L148.920344,157.180269 L145.078016,157.180269 L145.078016,161.819731 Z M144,163 L150,163 L150,156 L144,156 L144,163 Z",
    id: "Fill-20",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.078016,171.820628 L148.920344,171.820628 L148.920344,167.181166 L145.078016,167.181166 L145.078016,171.820628 Z M144,173 L150,173 L150,166 L144,166 L144,173 Z",
    id: "Fill-21",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.078016,182.819731 L148.920344,182.819731 L148.920344,178.181166 L145.078016,178.181166 L145.078016,182.819731 Z M144,184 L150,184 L150,177 L144,177 L144,184 Z",
    id: "Fill-22",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.078689,108.819731 L157.920492,108.819731 L157.920492,104.181166 L154.078689,104.181166 L154.078689,108.819731 Z M153,110 L159,110 L159,103 L153,103 L153,110 Z",
    id: "Fill-23",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.078689,119.819731 L157.920492,119.819731 L157.920492,115.180269 L154.078689,115.180269 L154.078689,119.819731 Z M153,121 L159,121 L159,114 L153,114 L153,121 Z",
    id: "Fill-24",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.078689,129.819731 L157.920492,129.819731 L157.920492,125.181166 L154.078689,125.181166 L154.078689,129.819731 Z M153,131 L159,131 L159,124 L153,124 L153,131 Z",
    id: "Fill-25",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.078689,140.819731 L157.920492,140.819731 L157.920492,136.180269 L154.078689,136.180269 L154.078689,140.819731 Z M153,142 L159,142 L159,135 L153,135 L153,142 Z",
    id: "Fill-26",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.078689,150.819731 L157.920492,150.819731 L157.920492,146.181166 L154.078689,146.181166 L154.078689,150.819731 Z M153,152 L159,152 L159,145 L153,145 L153,152 Z",
    id: "Fill-27",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.078689,161.819731 L157.920492,161.819731 L157.920492,157.180269 L154.078689,157.180269 L154.078689,161.819731 Z M153,163 L159,163 L159,156 L153,156 L153,163 Z",
    id: "Fill-28",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.078689,171.820628 L157.920492,171.820628 L157.920492,167.181166 L154.078689,167.181166 L154.078689,171.820628 Z M153,173 L159,173 L159,166 L153,166 L153,173 Z",
    id: "Fill-29",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.078689,182.819731 L157.920492,182.819731 L157.920492,178.181166 L154.078689,178.181166 L154.078689,182.819731 Z M153,184 L159,184 L159,177 L153,177 L153,184 Z",
    id: "Fill-30",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,71.8188341 L123.874837,71.8188341 L123.874837,67.1802691 L103.125163,67.1802691 L103.125163,71.8188341 Z M102,73 L125,73 L125,66 L102,66 L102,73 Z",
    id: "Fill-31",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,82.8188341 L123.874837,82.8188341 L123.874837,78.1793722 L103.125163,78.1793722 L103.125163,82.8188341 Z M102,84 L125,84 L125,77 L102,77 L102,84 Z",
    id: "Fill-32",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,93.8197309 L123.874837,93.8197309 L123.874837,89.1802691 L103.125163,89.1802691 L103.125163,93.8197309 Z M102,95 L125,95 L125,88 L102,88 L102,95 Z",
    id: "Fill-33",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,105.819731 L123.874837,105.819731 L123.874837,101.181166 L103.125163,101.181166 L103.125163,105.819731 Z M102,107 L125,107 L125,100 L102,100 L102,107 Z",
    id: "Fill-34",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,116.819882 L123.874837,116.819882 L123.874837,112.181015 L103.125163,112.181015 L103.125163,116.819882 Z M102,118 L125,118 L125,111 L102,111 L102,118 Z",
    id: "Fill-35",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,127.819731 L123.874837,127.819731 L123.874837,123.181166 L103.125163,123.181166 L103.125163,127.819731 Z M102,129 L125,129 L125,122 L102,122 L102,129 Z",
    id: "Fill-36",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,138.819731 L123.874837,138.819731 L123.874837,134.180269 L103.125163,134.180269 L103.125163,138.819731 Z M102,140 L125,140 L125,133 L102,133 L102,140 Z",
    id: "Fill-37",
    fill: "#0283FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,149.820628 L123.874837,149.820628 L123.874837,145.181166 L103.125163,145.181166 L103.125163,149.820628 Z M102,151 L125,151 L125,144 L102,144 L102,151 Z",
    id: "Fill-38",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,160.819731 L123.874837,160.819731 L123.874837,156.181166 L103.125163,156.181166 L103.125163,160.819731 Z M102,162 L125,162 L125,155 L102,155 L102,162 Z",
    id: "Fill-39",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,171.818834 L123.874837,171.818834 L123.874837,167.179372 L103.125163,167.179372 L103.125163,171.818834 Z M102,173 L125,173 L125,166 L102,166 L102,173 Z",
    id: "Fill-40",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125163,182.818834 L123.874837,182.818834 L123.874837,178.180269 L103.125163,178.180269 L103.125163,182.818834 Z M102,184 L125,184 L125,177 L102,177 L102,184 Z",
    id: "Fill-41",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,50.8206278 L67.8843347,50.8206278 L67.8843347,46.1811659 L57.1148182,46.1811659 L57.1148182,50.8206278 Z M56,52 L69,52 L69,45 L56,45 L56,52 Z",
    id: "Fill-42",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,50.8206278 L76.8576389,50.8206278 L76.8576389,46.1811659 L74.1432292,46.1811659 L74.1432292,50.8206278 Z M73,52 L78,52 L78,45 L73,45 L73,52 Z",
    id: "Fill-43",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,61.8197309 L67.8843347,61.8197309 L67.8843347,57.1802691 L57.1148182,57.1802691 L57.1148182,61.8197309 Z M56,63 L69,63 L69,56 L56,56 L56,63 Z",
    id: "Fill-44",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,61.8197309 L76.8576389,61.8197309 L76.8576389,57.1802691 L74.1432292,57.1802691 L74.1432292,61.8197309 Z M73,63 L78,63 L78,56 L73,56 L73,63 Z",
    id: "Fill-45",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,71.8198821 L67.8843347,71.8198821 L67.8843347,67.1810146 L57.1148182,67.1810146 L57.1148182,71.8198821 Z M56,73 L69,73 L69,66 L56,66 L56,73 Z",
    id: "Fill-46",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,71.8198821 L76.8576389,71.8198821 L76.8576389,67.1810146 L74.1432292,67.1810146 L74.1432292,71.8198821 Z M73,73 L78,73 L78,66 L73,66 L73,73 Z",
    id: "Fill-47",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,82.8188341 L67.8843347,82.8188341 L67.8843347,78.1793722 L57.1148182,78.1793722 L57.1148182,82.8188341 Z M56,84 L69,84 L69,77 L56,77 L56,84 Z",
    id: "Fill-48",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,82.8188341 L76.8576389,82.8188341 L76.8576389,78.1793722 L74.1432292,78.1793722 L74.1432292,82.8188341 Z M73,84 L78,84 L78,77 L73,77 L73,84 Z",
    id: "Fill-49",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,92.8197309 L67.8843347,92.8197309 L67.8843347,88.1802691 L57.1148182,88.1802691 L57.1148182,92.8197309 Z M56,94 L69,94 L69,87 L56,87 L56,94 Z",
    id: "Fill-50",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,92.8197309 L76.8576389,92.8197309 L76.8576389,88.1802691 L74.1432292,88.1802691 L74.1432292,92.8197309 Z M73,94 L78,94 L78,87 L73,87 L73,94 Z",
    id: "Fill-51",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,103.819731 L67.8843347,103.819731 L67.8843347,99.1811659 L57.1148182,99.1811659 L57.1148182,103.819731 Z M56,105 L69,105 L69,98 L56,98 L56,105 Z",
    id: "Fill-52",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,103.819731 L76.8576389,103.819731 L76.8576389,99.1811659 L74.1432292,99.1811659 L74.1432292,103.819731 Z M73,105 L78,105 L78,98 L73,98 L73,105 Z",
    id: "Fill-53",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,114.818834 L67.8843347,114.818834 L67.8843347,110.180269 L57.1148182,110.180269 L57.1148182,114.818834 Z M56,116 L69,116 L69,109 L56,109 L56,116 Z",
    id: "Fill-54",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,114.818834 L76.8576389,114.818834 L76.8576389,110.180269 L74.1432292,110.180269 L74.1432292,114.818834 Z M73,116 L78,116 L78,109 L73,109 L73,116 Z",
    id: "Fill-55",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,124.819731 L67.8843347,124.819731 L67.8843347,120.181166 L57.1148182,120.181166 L57.1148182,124.819731 Z M56,126 L69,126 L69,119 L56,119 L56,126 Z",
    id: "Fill-56",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,124.819731 L76.8576389,124.819731 L76.8576389,120.181166 L74.1432292,120.181166 L74.1432292,124.819731 Z M73,126 L78,126 L78,119 L73,119 L73,126 Z",
    id: "Fill-57",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,135.818834 L67.8843347,135.818834 L67.8843347,131.180269 L57.1148182,131.180269 L57.1148182,135.818834 Z M56,137 L69,137 L69,130 L56,130 L56,137 Z",
    id: "Fill-58",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,135.818834 L76.8576389,135.818834 L76.8576389,131.180269 L74.1432292,131.180269 L74.1432292,135.818834 Z M73,137 L78,137 L78,130 L73,130 L73,137 Z",
    id: "Fill-59",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,146.819731 L67.8843347,146.819731 L67.8843347,142.181166 L57.1148182,142.181166 L57.1148182,146.819731 Z M56,148 L69,148 L69,141 L56,141 L56,148 Z",
    id: "Fill-60",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,146.819731 L76.8576389,146.819731 L76.8576389,142.181166 L74.1432292,142.181166 L74.1432292,146.819731 Z M73,148 L78,148 L78,141 L73,141 L73,148 Z",
    id: "Fill-61",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,156.819731 L67.8843347,156.819731 L67.8843347,152.180269 L57.1148182,152.180269 L57.1148182,156.819731 Z M56,158 L69,158 L69,151 L56,151 L56,158 Z",
    id: "Fill-62",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,156.819731 L76.8576389,156.819731 L76.8576389,152.180269 L74.1432292,152.180269 L74.1432292,156.819731 Z M73,158 L78,158 L78,151 L73,151 L73,158 Z",
    id: "Fill-63",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,167.820628 L67.8843347,167.820628 L67.8843347,163.181166 L57.1148182,163.181166 L57.1148182,167.820628 Z M56,169 L69,169 L69,162 L56,162 L56,169 Z",
    id: "Fill-64",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,167.820628 L76.8576389,167.820628 L76.8576389,163.181166 L74.1432292,163.181166 L74.1432292,167.820628 Z M73,169 L78,169 L78,162 L73,162 L73,169 Z",
    id: "Fill-65",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1148182,177.819731 L67.8843347,177.819731 L67.8843347,173.180269 L57.1148182,173.180269 L57.1148182,177.819731 Z M56,179 L69,179 L69,172 L56,172 L56,179 Z",
    id: "Fill-66",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1432292,177.819731 L76.8576389,177.819731 L76.8576389,173.180269 L74.1432292,173.180269 L74.1432292,177.819731 Z M73,179 L78,179 L78,172 L73,172 L73,179 Z",
    id: "Fill-67",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#231F20",
    points: "91 199 92 199 92 1 91 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    fill: "#401737",
    points: "128 192 129 192 129 51 128 51"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-77",
    transform: "translate(44.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79273488,11.4901261 L5.95515349,11.8883 C6.5227814,13.2835609 7.87236279,14.1848217 9.39273488,14.1848217 C11.0286419,14.1848217 12.4518977,13.1497348 12.9341302,11.6090826 L13.0270605,11.3141696 L13.3309674,11.2406478 C13.9940372,11.0828652 14.6077116,10.8003435 15.1577581,10.4013435 L15.5478977,10.1171696 L15.8827814,10.4641261 C16.5910605,11.1960391 17.5421302,11.5991696 18.5626884,11.5991696 C20.6063163,11.5991696 22.269014,9.95856087 22.269014,7.94208261 C22.269014,5.92643043 20.6063163,4.28499565 18.5626884,4.28499565 C18.1784093,4.28499565 17.7966419,4.34447391 17.4274326,4.46095217 L16.9669674,4.60799565 L16.761014,4.17595217 C15.9187814,2.41060435 14.0978512,1.26977826 12.1220372,1.26977826 C10.0114326,1.26977826 8.14194419,2.52047391 7.36082791,4.45599565 L7.12975814,5.02682174 L6.58389767,4.7319087 C6.04222326,4.4403 5.42854884,4.28499565 4.80817674,4.28499565 C2.76454884,4.28499565 1.10185116,5.92643043 1.10185116,7.94208261 C1.10185116,9.95856087 2.76454884,11.5991696 4.80817674,11.5991696 C4.9756186,11.5991696 5.15143256,11.5843 5.36157209,11.5537348 L5.79273488,11.4901261 Z M9.39273488,15.2719522 C7.56259535,15.2719522 5.92333953,14.2649522 5.10789767,12.676387 C5.00575814,12.6829957 4.90613023,12.6863 4.80817674,12.6863 C2.15673488,12.6863 8.37209302e-05,10.5583 8.37209302e-05,7.94208261 C8.37209302e-05,5.32586522 2.15673488,3.19786522 4.80817674,3.19786522 C5.41431628,3.19786522 6.01626977,3.31186522 6.5772,3.52995217 C7.63459535,1.47877826 9.75273488,0.182647826 12.1220372,0.182647826 C14.3674326,0.182647826 16.4478977,1.3936913 17.5446419,3.30608261 C17.8795256,3.23421304 18.2202698,3.19786522 18.5626884,3.19786522 C21.213293,3.19786522 23.3707814,5.32586522 23.3707814,7.94208261 C23.3707814,10.5583 21.213293,12.6863 18.5626884,12.6863 C17.3956186,12.6863 16.2988744,12.2806913 15.4265023,11.5355609 C14.9467814,11.8321261 14.4310605,12.0609522 13.8860372,12.2195609 C13.1785953,14.0567783 11.4104093,15.2719522 9.39273488,15.2719522 L9.39273488,15.2719522 Z",
    id: "Fill-70",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-72",
    fill: "#000000",
    points: "15.1032558 19 16.2050233 19 16.2050233 11.2868261 15.1032558 11.2868261"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    fill: "#000000",
    points: "11.2546047 19 12.3563721 19 12.3563721 13.8972609 11.2546047 13.8972609"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    fill: "#000000",
    points: "16.0678047 16.5837783 15.2883628 15.8146913 17.2725488 13.8568652 18.0519907 14.6259522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7772465,17.7309652 L141.75427,17.7309652 C140.855944,16.2150957 139.185712,15.2411391 137.37734,15.2411391 C136.489898,15.2411391 135.612502,15.4757478 134.838921,15.9185304 L134.612037,16.0474 L134.367572,15.9573565 C133.717898,15.715313 133.038084,15.4807043 132.348223,15.2601391 L132.100409,15.1808348 L132.004967,14.9404435 C131.650828,14.042487 130.793526,13.4634 129.819851,13.4634 C129.29827,13.4634 128.802642,13.6302696 128.387386,13.948313 L128.179758,14.1060957 L127.923572,14.0466174 C126.929805,13.815313 125.900874,13.6005304 124.866084,13.4088783 L124.522828,13.3444435 L124.434084,13.0123565 C123.701526,10.2557043 121.173991,8.33009565 118.288967,8.33009565 C115.883665,8.33009565 113.71027,9.6510087 112.618549,11.7757043 L112.459479,12.0838348 L111.273991,12.0491391 L111.130828,11.7410087 C110.306177,9.96409565 108.49613,8.8150087 106.521153,8.8150087 C105.91334,8.8150087 105.308874,8.92653043 104.72534,9.14461739 L104.369526,9.27844348 L104.116688,8.99674783 C102.714363,7.43131304 100.697526,6.53418261 98.5852465,6.53418261 C95.1217116,6.53418261 92.163014,8.85796522 91.3885953,12.1846174 L91.2345488,12.8471391 L90.6133395,12.5530522 C89.919293,12.2242696 89.183386,12.0582261 88.4257116,12.0582261 C87.539107,12.0582261 86.6625488,12.2911826 85.8889674,12.7331391 L85.6126884,12.8917478 L85.3372465,12.7331391 C84.5636651,12.2911826 83.687107,12.0582261 82.8005023,12.0582261 C80.003386,12.0582261 77.727014,14.3043565 77.727014,17.063487 C77.727014,17.2840522 77.7437581,17.5046174 77.7772465,17.7309652 L77.7772465,17.7309652 Z M143.426177,18.8180957 L76.8797581,18.8180957 L76.7826419,18.3951391 C76.6771535,17.9350087 76.6260837,17.4996609 76.6260837,17.063487 C76.6260837,13.7037913 79.3964093,10.9702696 82.8005023,10.9702696 C83.7766884,10.9702696 84.7419907,11.2032261 85.6126884,11.6435304 C87.1138047,10.8835304 88.9045953,10.7645739 90.4835721,11.3230087 C91.5794791,7.8327913 94.8236651,5.44705217 98.5852465,5.44705217 C100.889247,5.44705217 103.093619,6.37557391 104.690177,8.00709565 C105.287944,7.82205217 105.902456,7.72870435 106.521153,7.72870435 C108.748967,7.72870435 110.803479,8.92818261 111.892688,10.8248783 C113.238921,8.60187826 115.644223,7.2437913 118.288967,7.2437913 C121.556595,7.2437913 124.434084,9.34783478 125.402735,12.4027043 C126.258363,12.5654435 127.106456,12.7430522 127.933619,12.9322261 C128.495386,12.5670957 129.142549,12.3762696 129.819851,12.3762696 C131.160223,12.3762696 132.352409,13.1238783 132.925898,14.3027043 C133.465898,14.4778348 134.000037,14.6620522 134.517433,14.8512261 C135.400688,14.3944 136.383572,14.1540087 137.37734,14.1540087 C139.919107,14.1540087 142.235665,15.7318348 143.141526,18.0820522 L143.426177,18.8180957 Z",
    id: "Fill-76",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    x: 0,
    y: 198,
    width: 217,
    height: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.dc32f72d.svg";
export { ForwardRef as ReactComponent };